const machine_txt = {
    type: "VA-75A-4D",
    name: "Direct Drive High Speed Overlock Sewing Machine",
    description: [
        "Equipped with direct-drive servo motor. Can save 70% electricity super worksp-ace,adopt advanced feeding mechanism, prevent leaping in high-speed at lower tension.,upgrading the efficiency. Beautiful appearance.Easily operation,lower noise,without radiation.Suitable for light,medium,heavy of garment sewing.",
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/6/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/6/machine_other/1.png",
        "/assets/machine/6/machine_other/2.png",
        "/assets/machine/6/machine_other/3.png",
    ]
}
export default {machine_txt}